export default __webpack_public_path__ + "static/media/Archpriest's Boots of the Black Thread.3b6040c8.jpg";